export var COUNTRY_ENUM;
(function (COUNTRY_ENUM) {
    COUNTRY_ENUM["SG"] = "SG";
    COUNTRY_ENUM["TW"] = "TW";
    COUNTRY_ENUM["ID"] = "ID";
    COUNTRY_ENUM["PH"] = "PH";
    COUNTRY_ENUM["MY"] = "MY";
    COUNTRY_ENUM["HK"] = "HK";
    COUNTRY_ENUM["TH"] = "TH";
    COUNTRY_ENUM["VN"] = "VN";
})(COUNTRY_ENUM || (COUNTRY_ENUM = {}));
